import { Close as CloseIcon, FilterList as FilterIcon, MoreVert as MoreIcon } from '@mui/icons-material';
import { useState } from 'react';
import { useCommsFilter } from '../../../../hooks/use-communications';
import { FilterChip, FilterChipsContainer } from '../filter-widget/styles/inbox-filter-styles';
import { InboxIconButton } from '../inbox-widget/styles/inbox-styles';
import CommsActionsMenuList from './communications-actions';
import { Status } from './communications-widget';
import { CommsHeader } from './styles/communcations-styles';

interface CommunitcationsFiltersProps {
  patientPhoneNumbers: string[];
  finalStatus: Status;
  patientMailboxIds: number[];
  handleDeleteCommType: () => void;
  handleDeleteDeliveryType: () => void;
  onClickFilter: () => void;
}

export const CommunicationsFilters = ({
  patientPhoneNumbers,
  onClickFilter,
  finalStatus,
  patientMailboxIds,
  handleDeleteCommType,
  handleDeleteDeliveryType
}: CommunitcationsFiltersProps) => {
  const { commsFilter } = useCommsFilter();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const onClickMore = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <CommsHeader className="communications-filters-header">
        <InboxIconButton onClick={onClickFilter}>
          <FilterIcon fontSize="small" />
        </InboxIconButton>
        {!!patientPhoneNumbers.length && (
          <InboxIconButton onClick={onClickMore} toggled={!!anchorEl}>
            <MoreIcon fontSize="small" />
          </InboxIconButton>
        )}
        <CommsActionsMenuList
          patientPhoneNumbers={patientPhoneNumbers}
          patientMailboxIds={patientMailboxIds}
          channelStatus={finalStatus}
          anchorEl={anchorEl}
          handleClose={handleClose}
        />
      </CommsHeader>
      {commsFilter.commType || commsFilter.deliveryType ? (
        <FilterChipsContainer>
          {commsFilter.commType && (
            <FilterChip
              label={commsFilter.commType}
              variant="outlined"
              deleteIcon={<CloseIcon />}
              onDelete={handleDeleteCommType}
            />
          )}
          {commsFilter.deliveryType && (
            <FilterChip
              label={commsFilter.deliveryType}
              variant="outlined"
              deleteIcon={<CloseIcon />}
              onDelete={handleDeleteDeliveryType}
            />
          )}
        </FilterChipsContainer>
      ) : null}
    </>
  );
};
